import * as $ from 'jquery'

const $dropdownButtons = $('.js-dropdownButton')
const $dropdowns = $('.js-dropdown')
const $navBar = $('.site__navbar2')

$dropdownButtons.on('click', function(event) {
    const $this = $(this)
    const dropdownID = $this.data('dropdown')
    const $associatedDropdown = $(`.js-dropdown[data-dropdown="${dropdownID}"]`)
    // associatedMenuItem updates the + - on the menu item and the color bar that connects to the menu
    const $associatedMenuItem = $(`.${dropdownID}-submenu`)

    if(!$associatedDropdown.hasClass('-isOpen')) {

        $associatedDropdown.addClass('-isOpen')
        $associatedMenuItem.addClass('-isOpen')
        event.stopPropagation()

        $dropdowns.fadeOut(250)

        $associatedDropdown
            .css('display', 'flex')
            .hide()
            .fadeIn({
                duration: 250,
            })
            

            // Closes submenu if submenu and submenu button lose focus
            $(document).on('focusout', function(e) {
                if ($associatedDropdown.hasClass('-isOpen') && !$this.is(e.relatedTarget) && !$associatedDropdown.has(e.relatedTarget).length) {
                    $associatedDropdown.fadeOut(250);
                    $associatedDropdown.removeClass('-isOpen');
                    $associatedMenuItem.removeClass('-isOpen');
                }
            });

        $(window).on('click', function(event) {
            // event.preventDefault()  // causing mouse click to fail, removed.

            const associatedDropdownEl = $associatedDropdown[0]
            const eventPath = event.originalEvent.composedPath()

            if (!eventPath.includes(associatedDropdownEl)) {
                $associatedDropdown.fadeOut(250)
                //Added this to remove class if closing - necessary? 
                $associatedDropdown.removeClass('-isOpen')
                $associatedMenuItem.removeClass('-isOpen');              
            }
        })
        // Close menu when escape key is pressed
        $($navBar).on('keydown', function(e) {
            if(e.key === 'Escape') {
                $associatedDropdown.fadeOut(250)
                $associatedDropdown.removeClass('-isOpen')
                $associatedMenuItem.removeClass('-isOpen');
            }
        })  
                
    } else {
        $associatedDropdown.removeClass('-isOpen')
        $associatedMenuItem.removeClass('-isOpen');              
        $associatedDropdown.fadeOut(250)
    }
})
